import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
// Constants
import { UnoLeftNavBoxShadow, UnoLeftNavMaxWidth, UnoLeftNavWidth } from "@ms/uno-controls/lib/local/constants/StyleConstants";
/**
 * Styles for the Left Nav placeholder
 */ export const useLeftNavPlaceholderStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        width: UnoLeftNavWidth,
        maxWidth: UnoLeftNavMaxWidth,
        backgroundColor: tokens.colorNeutralBackground1,
        boxShadow: UnoLeftNavBoxShadow,
        ...shorthands.borderRight("1px", "solid", tokens.colorNeutralStroke1)
    }
});
